import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAberrations } from '../../interfaces/aberrations.interface';
import { CurationStatusValue } from '../../interfaces/curation-status';

@Component({
  selector:        'gen-curation-status',
  templateUrl:     './curation-status.component.html',
  styleUrls:       ['./curation-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationStatusComponent {
  @Input('columnValue')
  aberration: IAberrations;

  constructor() {
  }

  get wasCurated(): boolean {
    return this.aberration.manualCurationStatus && this.aberration.manualCurationStatus.value === CurationStatusValue.Curated;
  }
}
